import { isEmpty } from 'lodash'
import { getObjectFields } from '~/Util'
import * as ActionTypes from '~/actions/ActionTypes'
import { updateAssetInPreview } from '~/actions/layer'
import { loadProjectAsset, rewind, setSliderTimeCenter } from '~/actions/timeline'
import { getAssetFromData, rebuildAssets } from '~/actions/projectData/mappings/getAssetMapping'


export const addAssetToTimeline = ({ originalAsset, layerId, pregeneratedId,
  initialStartTime }) => async dispatch => {
  const asset = getAssetFromData(getObjectFields(originalAsset))
  const {
    startTime,
    id,
  } = asset
  await dispatch(loadProjectAsset(asset,
    { layerId: layerId || asset.layerId,
      startTime: initialStartTime || startTime,
      pregeneratedId: pregeneratedId || id }))
  if (asset.settings) {
    const { settings } = asset
    await dispatch(updateAssetInPreview(id, { settings }))
  }
}

export const addCopiedAssetsToTimeLine = (originalAssets, copiedAssetsTransitions,
  {
    sliderTime,
    newLayersIds,
    prevSelectedAssetIds,
    insertionLayerIndex,
    prevLayersMap,
  }) => async (dispatch, getState) => {
  const state = getState()
  const preparedAssets = rebuildAssets(originalAssets)
  const newSliderTime = getMaxEndTime(originalAssets)
  const { copyType } = state.layer

  if (!isEmpty(preparedAssets)) {
    dispatch({
      type: ActionTypes.COPIED_ASSET_ADDED_TO_TIMELINE,
      payload: {
        assets: preparedAssets,
        transitions: copiedAssetsTransitions,
        prevSliderTime: sliderTime,
        newSliderTime,
        newLayersIds,
        prevLayersMap,
        prevSelectedAssetIds,
        insertionLayerIndex,
        copyType,
      },
    })
    if (newSliderTime) {
      dispatch(rewind(newSliderTime))
      dispatch(setSliderTimeCenter(newSliderTime, true))
    }
  }
}


function getMaxEndTime(originalAssets) {
  let maxEndTime = 0
  if (!isEmpty(originalAssets)) {
    originalAssets.forEach(asset => {
      if (asset.endTime > maxEndTime) {
        maxEndTime = asset.endTime
      }
    })
  }
  return maxEndTime
}
